import { render, staticRenderFns } from "./g-map-data-processing.vue?vue&type=template&id=c16c0c5a&scoped=true"
import script from "./g-map-data-processing.vue?vue&type=script&lang=js"
export * from "./g-map-data-processing.vue?vue&type=script&lang=js"
import style0 from "./g-map-data-processing.vue?vue&type=style&index=0&id=c16c0c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16c0c5a",
  null
  
)

export default component.exports